import Vue from 'vue';

export default {
  state: {
    selectedTab: null,
    firstRecipeLoaded: false,
    dairyInfo: {
      milk: 26,
      weight: 550,
      protein: 3.6,
      fat: 3.8,
      meadow: {},
      forage: [],
    },
    nutritionFormulator: {
      protein: 16,
      energy: 3,
      fdn: 40,
      cne: 45,
      salt: { amount: 0, id: null },
      additives: [
        { id: null, amount: 0 },
        { id: null, amount: 0 },
        { id: null, amount: 0 },
      ],
      additiveCounter: 1,
      ingredientRanges: {},
      showExtension: false,
      showExtensionIngredients: false,
    },
    ingredientFormulator: {
      ingredients: {},
      salts: [
        { amount: 0, id: null },
        { amount: 0, id: null },
      ],
      additiveCounter: 1,
      showExtension: false,
      showExtensionIngredients: false,
      additives: [
        { id: null, amount: 0 },
        { id: null, amount: 0 },
        { id: null, amount: 0 },
      ],
    },
    via: null,
  },
  mutations: {
    updateDairyInfo: (state, payload) => {
      state.dairyInfo[payload.key] = payload.value;
    },
    setSelectedTab: (state, payload) => {
      // Normalize legacy persisted Coagra tab: 'coagra' was retired in favor of
      // reusing the 'ingredient' tab with Coagra-specific behavior via
      // `state.order.isCoagraWeb`. Coerce on any write to keep the store
      // consistent even after vuex-persist rehydrates an old session.
      state.selectedTab = payload === 'coagra' ? 'ingredient' : payload;
    },
    updateNutritionFormulator: (state, payload) => {
      state.nutritionFormulator = { ...state.nutritionFormulator, ...payload };
    },
    updateIngredientFormulator: (state, payload) => {
      state.ingredientFormulator = { ...state.ingredientFormulator, ...payload };
    },
    updateIngredientFormulatorIngredients: (state, payload) => {
      state.ingredientFormulator.ingredients = { ...state.ingredientFormulator.ingredients, ...payload };
    },
    setIngredientFormulatorIngredients: (state, payload) => {
      state.ingredientFormulator.ingredients = payload;
    },
    setIngredientFormulatorSalt: (state, payload) => {
      Vue.set(state.ingredientFormulator.salts, payload.index, payload.value);
    },
    setIngredientFormulatorAdditive: (state, payload) => {
      Vue.set(state.ingredientFormulator.additives, payload.index, payload.value);
    },
    updateFirstRecipeLoaded: (state, payload) => {
      state.firstRecipeLoaded = payload;
    },
    updateVia: (state, payload) => {
      state.via = payload;
    },
  },
  actions: {
    setIngredientRanges: ({ commit, state, getters }) => {
      const ranges = getters.generalIngredients.reduce(
        (acc, ingredient) => ({ ...acc, [ingredient.id]: ingredient.rangeValue }), {},
      );
      commit(
        'updateNutritionFormulator',
        { ingredientRanges: { ...ranges, ...state.nutritionFormulator.ingredientRanges } },
      );
    },
    setIngredientFormulatorValues({ commit, state, getters }) {
      const validIds = new Set(getters.generalIngredients.map(i => String(i.id)));
      const persisted = Object.fromEntries(
        Object.entries(state.ingredientFormulator.ingredients).filter(([id]) => validIds.has(String(id))),
      );
      const values = getters.generalIngredients.reduce(
        (acc, ingredient) => ({ ...acc, [ingredient.id]: ingredient.value }), {},
      );
      commit('setIngredientFormulatorIngredients', { ...values, ...persisted });
    },
  },
};
